import {
  Box,
  Card,
  CardContent,
  Container,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { slideRight, slideUp } from "util/transitions";
import Lottie from "react-lottie-player";
import animationData from "./404.json";
import clsx from "clsx";
import { heroSlideUp, errorSlideup } from "../../util/transitions";

const useStyles = makeStyles((theme) => ({
  notFound: {
    width: 300,
  },
  lottieWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },

    height: "100%",
  },
  logoContainer: {
    height: 92,
    width: "100%",
    marginTop: "100px",
    position: "relative",
    marginLeft: "0px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "-10px",
    },
  },
  rootContainer: {
    height: props => {
      console.log("📢[index.js:48]:", props);
      return `calc(100vh - ${props.bar?theme.mixins.toolbar.minHeight:0}px)`
    },
    overflowY:"none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    
  },
  container: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  hero: {
    fontWeight: "bolder",
    [theme.breakpoints.down("sm")]: {
      fontSize: 25,
      lineHeight: "29.3px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 50,
      lineHeight: "58.59px",
    },
  },
  white: {
    color: theme.palette.common.white,
  },
  textBody: {
    fontWeight: 400,
    size: "20px",
    lineHeight: "23.44px",
  },
  block: {
    paddingBottom: "19px",
  },
  heroBlock: {
    paddingTop: "64px",
    [theme.breakpoints.down("md")]: {
      paddingTop: "30px",
    },
  },
  heroButton: {
    fontSize: "30px",
    padding: "15px 63px",
    letterSpacing: 0,
    [theme.breakpoints.down("md")]: {
      fontSize: 15,
      padding: "15px 33px",
    },
  },
  mobileStore: {
    "& > *": {
      marginRight: theme.spacing(2),
    },
  },
}));

export const NotFound = (props) => {
  const classes = useStyles(props);
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [startLottieAnim, setStartLottieAnim] = useState(false);

  return (
    <motion.div
      {...errorSlideup(theme.mixins.toolbar.minHeight)}
      onAnimationComplete={(def) => setStartLottieAnim(true)}
    >
      <Container className={classes.rootContainer}>
        <Box className={classes.container}>
          <Lottie
            play={startLottieAnim}
            loop={0}
            animationData={animationData}
            className={classes.notFound}
          />

          <Box className={clsx(classes.heroBlock, classes.block)}>
            <span className={classes.hero}>
              <span className={clsx(classes.white)}>Not Found</span>
            </span>
          </Box>
        </Box>
      </Container>
    </motion.div>
  );
};
